import { Routes } from "@angular/router";
import { loadPermissionsGuard } from "./core/permissions/permission.guard";
import { authGuard } from "./guards/auth.guard";
import { screenLockGuard } from "./guards/screen-lock.guard";
import { AppLayout } from "./layouts/app-layout";
import { AuthLayout } from "./layouts/auth-layout";

export const routes: Routes = [
  {
    path: "mock-profiles",
    loadComponent: () =>
      import("./pages/mock-kyc-profiles/mock-kyc-profiles-page.component").then(
        (m) => m.MockKycProfilesPageComponent,
      ),
  },
  {
    path: "digilocker/callback",
    loadComponent: () =>
      import("./pages/digilocker/digilocker-callback.component").then(
        (m) => m.DigilockerCallbackComponent,
      ),
  },
  {
    path: "kyc/callback",
    loadComponent: () =>
      import("./pages/digilocker/digilocker-callback.component").then(
        (m) => m.DigilockerCallbackComponent,
      ),
  },
  {
    path: "account-aggregator/mock-consent",
    loadComponent: () =>
      import(
        "./pages/account-aggregator/account-aggregator-mock-consent.component"
      ).then((m) => m.AccountAggregatorMockConsentComponent),
  },
  {
    path: "auth",
    component: AuthLayout,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/auth/auth.routes").then((m) => m.AUTH_ROUTES),
      },
    ],
  },
  {
    path: "",
    component: AppLayout,
    canActivate: [authGuard, loadPermissionsGuard, screenLockGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/pages.route").then((m) => m.PAGE_ROUTES),
      },
    ],
  },
];
